import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { SnotifyService } from 'ng-snotify';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  email: string = "";
  userId: string = "";
  password: string = "";
  passwordConfirm: string = "";
  mfa: string = "";
  invalid: boolean = false;
  showMFA: boolean = false;
  showForgotPassword: boolean = false;
  showReset: boolean = false;
  code;
  constructor(private authService: AuthService, private snotifyService: SnotifyService,private route: ActivatedRoute,public router: Router) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      console.log("params");
      console.log(params);
      this.userId = params['userId'];
      this.code = params['code'];
      if (this.userId != undefined) {
        this.showReset = true;
      }
      console.log(this.userId);
      console.log(this.code);


    });
  }

  onLogin() {
    this.invalid = false;
    this.authService.login(this.email, this.password).then((result) => {
      if (result.mfa) {
        this.showMFA = true;
        this.userId = result.id;
      } else{
        this.router.navigate(['./dashboard']);

      }
    }, (error) => {
      this.invalid = true;
    });
  }
  passwordReset() {
    this.invalid = false;
    this.authService.resetPassword(this.email).then((result) => {
      this.snotifyService.success("Successfully sent password reset code");
      this.snotifyService.success("Please check your spam folder");
    }, (error) => {
      // this.invalid = true;
    });
  }
  
  confirmResetPassword() {
    if (this.password == '' || this.password == null) {
      this.snotifyService.error('Please enter password');
      return;
    }

    if (this.password != this.passwordConfirm) {
      this.snotifyService.error('Passwords do not match');
      return;
    }
    console.log("User ID:");
    console.log(this.userId);
    let model = {
      Id: this.userId,
      Password: this.password,
      Code: this.code
    };

     this.authService.changepassword(model).then((result) => {
      this.snotifyService.success("Successfully reset password");
      this.showLogin();
    }, (error) => {
      // this.invalid = true;
    });

   
  }


  showPassword(){
        this.showForgotPassword = true;
  }

  showLogin() {
    this.showForgotPassword = false;
    this.showMFA = false;
    this.showReset = false;
  }

  onOtpChange(val) {
    this.mfa = val;
  }

  confirmMFAPassword() {
    //console.log("confirming password");
    //console.log(this.mfa);

    if (this.mfa == '' || this.mfa == undefined || this.mfa == null) {
      this.snotifyService.error("Please enter the code");
      return;
    }
   this.authService.confirmMFA(this.email, this.password, this.mfa, this.userId).then((result) => {
      if (result.mfa) {
        this.showMFA = true;
      }
    }, (error) => {
      this.invalid = true;
    });

  }
}
